import { Transformation } from 'app/model/dataflow/transformation';
import { TransformConvertorBase } from './transform.convertor';
import { AssertTransformation } from 'app/model/dataflow/asserttransformation';
import { AssertPlainObject } from 'worker/app-workers/shared/plainObjects/assert.plainObject';
import { DataFlowExpressionUtils } from '../../expression.util';
import { BooleanDataFlowType, StringDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { AssertExpressionType, IResourceContext, Owned } from 'shell-models-lib';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';

export class AssertConvertor extends TransformConvertorBase {
    private get assertTransform(): AssertTransformation {
        return this.transformation as AssertTransformation;
    }

    private get assertObject(): AssertPlainObject {
        return this.transformObject as AssertPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        this.assertObject.asserts.forEach((assertExpression) => {
            const expression = this.assertTransform.addAssertExpression();
            expression.assertType = assertExpression.assertType;
            switch (expression.assertType) {
                case AssertExpressionType.ExpectTrue:
                    expression.trueExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                        assertExpression.trueExpression
                    );
                    expression.trueExpression.returnType = new BooleanDataFlowType();
                    break;
                case AssertExpressionType.ExpectUnique:
                    expression.uniqueExpressions = [];
                    assertExpression.uniqueExpressions.forEach((uniqueExpression) => {
                        const dfExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, expression);
                        dfExpression.expression =
                            DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(uniqueExpression);
                        dfExpression.returnType = new StringDataFlowType();
                        expression.uniqueExpressions.push(dfExpression);
                    });
                    break;
                case AssertExpressionType.ExpectExists:
                    const expectExists = assertExpression.existsExpression.split(' ');
                    expression.existsLeftExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                        expectExists[0]
                    );
                    expression.existsLeftExpression.returnType = new StringDataFlowType();
                    expression.existsRightExpression.expression =
                        DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(expectExists[2]);
                    expression.existsRightExpression.returnType = new StringDataFlowType();
                    break;
                default:
                    break;
            }
            expression.assertId = DataFlowExpressionUtils.extractStringConfigValue(assertExpression.assertId);
            expression.ignoreNulls = assertExpression.ignoreNulls;
            if (assertExpression.filter) {
                expression.filterExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                    assertExpression.filter
                );
                expression.filterExpression.returnType = new BooleanDataFlowType();
            }
            if (assertExpression.assertDescription) {
                expression.assertDescription.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                    assertExpression.assertDescription
                );
                expression.assertDescription.returnType = new StringDataFlowType();
            }
        });

        this.assertObject.configs.forEach((expression, configName) => {
            if (configName === 'abort') {
                this.assertTransform.abort = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                    expression,
                    this.assertTransform,
                    BooleanDataFlowType.TYPE
                );
                this._handledConfigs.push(configName);
            }
        });

        super.postConvert();
        return this.assertTransform;
    }
}
